
<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <div class="col-md-12 index-up">
                <app-breadcrumb></app-breadcrumb>
                <h2>Appel à Manifestation d’Intérêt </h2>
                <p  class="text-primary size18 font-weight-semibold">
                </p>

            </div>
        </div>
    </div>

    <section >
        <div class="container">
            <div class="row">
                <div class="col-md-12">

<div *ngIf="!download">       
 <h5 >Merci de remplire le formulaire pour télécharger le dossier</h5> 
 <br>

<div class="col-md-12 d-flex align-items-center justify-content-center">
      <!-- Form starts here -->
<form #myForm="ngForm" (ngSubmit)="onSubmit(myForm)" novalidate style="background-color: white;">

    <!-- Nom et prénom -->
    <div class="form-group">
      <label for="fullName">Nom et prénom *</label>
      <input type="text" class="form-control" id="fullName" name="fullName" required [(ngModel)]="fullName">
      <div *ngIf="myForm.submitted && !myForm.controls['fullName']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
    <!-- Raison sociale de l’entreprise -->
    <div class="form-group">
      <label for="companyName">Raison sociale *</label>
      <input type="text" class="form-control" id="companyName" name="companyName" required [(ngModel)]="companyName">
      <div *ngIf="myForm.submitted && !myForm.controls['companyName']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
        <!-- Secteur d'activité  -->
        <div class="form-group">
            <label for="secteur">Secteur d'activité *</label>
            <input type="text" class="form-control" id="secteur" name="secteur" required [(ngModel)]="secteur">
            <div *ngIf="myForm.submitted && !myForm.controls['secteur']?.valid" class="text-danger">
              Ce champ est obligatoire.
            </div>
          </div>

    <!-- N° Téléphone de l’entreprise -->
    <div class="form-group">
      <label for="companyPhone">N° Téléphone *</label>
      <input type="tel" class="form-control" id="companyPhone" name="companyPhone" required [(ngModel)]="companyPhone">
      <div *ngIf="myForm.submitted && !myForm.controls['companyPhone']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
      
    <!-- Adresse email de la personne -->
    <div class="form-group">
        <label for="email">Adresse email *</label>
        <input type="email" class="form-control" id="email" name="email" required [(ngModel)]="email">
        <div *ngIf="myForm.submitted && !myForm.controls['email']?.valid" class="text-danger">
          Entrez une adresse email valide.
        </div>
      </div>
  
    <!-- Cocher les conditions d’utilisation et de confidentialité -->
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" id="terms" name="terms" required [(ngModel)]="terms">
      <label class="form-check-label" for="terms">J'accepte <a routerLink="/acces-rapide/legalnotice" target="_blank"> les conditions d’utilisation et de confidentialité</a> *</label>
      <div *ngIf="myForm.submitted && !myForm.controls['terms']?.valid" class="text-danger">
        Vous devez accepter les conditions.
      </div>
    </div>
  
    <!-- Error message -->
    <div class="form-group form-check">
      <label style="color: red;" class="form-check-label" for="terms">{{error}}</label>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!myForm.valid" (click)="onSubmit(myForm)">Télécharger</button>
  </form>
  <!-- Form ends here -->
</div>
</div>
<div *ngIf="download" style="height: 600px; padding-top: 100px;"> 
    <h5> Merci d'avoir télécharger le dossier de l'appel à manifestation d'intérêt </h5>
</div>
</div> 



</div>
        </div>
</section>
</main>
